import { createDesignCart, readDesign, attachmentURL, lockCart } from './hnl-number-cart.js?v=overall-height-386ebecff4e22b60';
import { styles } from './hnl-number-catalog.js?v=overall-height-386ebecff4e22b60';

const configElement = document.querySelector('#hnl-cart-config');
if (configElement) {
  const { root, copy } = JSON.parse(configElement.textContent);
  const api = createDesignCart({ root });
  const cartURL = new URL(root + 'cart', location.origin);
  const preview = new URL(location.href).searchParams.get('preview_theme_id');
  if (preview) cartURL.searchParams.set('preview_theme_id', preview);
  const notice = document.createElement('div');
  notice.className = 'hnl-cart-notice';
  notice.hidden = true;
  notice.setAttribute('role', 'status');
  const message = document.createElement('p');
  const retry = document.createElement('button');
  retry.type = 'button'; retry.textContent = copy.check_saved;
  const cancel = document.createElement('button');
  cancel.type = 'button'; cancel.textContent = copy.cancel_update;
  const link = document.createElement('a');
  link.href = cartURL.href; link.textContent = copy.view_cart;
  notice.append(message, retry, document.createTextNode(' '), cancel, document.createTextNode(' '), link);
  (document.querySelector('#cart_form') || document.body).prepend(notice);
  let checking = false;
  const showError = error => {
    notice.hidden = false;
    message.textContent = error.message === 'pending' ? copy.cart_pending : copy.cart_error;
    if (location.pathname !== cartURL.pathname) cancel.hidden = true;
    notice.scrollIntoView({ block: 'center' });
    retry.focus();
  };
  const check = async () => {
    if (checking) throw new Error('pending');
    checking = true;
    retry.disabled = cancel.disabled = true;
    try { return await lockCart(() => api.reconcile()); }
    finally { checking = false; retry.disabled = cancel.disabled = false; }
  };
  retry.addEventListener('click', async () => {
    try { await check(); location.assign(cartURL.href); } catch (error) { showError(error); }
  });
  cancel.addEventListener('click', async () => {
    if (checking) return;
    checking = true;
    retry.disabled = cancel.disabled = true;
    try { await lockCart(() => api.cancel()); location.assign(cartURL.href); }
    catch (error) { showError(error); }
    finally { checking = false; retry.disabled = cancel.disabled = false; }
  });
  const allowed = new WeakSet();
  document.addEventListener('click', async event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = new URL(anchor.href, location.origin);
    if (target.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?checkout(?:\/|$)/.test(target.pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try { await check(); location.assign(target.href); } catch (error) { showError(error); }
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (allowed.has(form)) { allowed.delete(form); return; }
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    try {
      const before = await api.read();
      await check();
      if (before.attributes?._hnl_pending) { location.assign(cartURL.href); return; }
      allowed.add(form);
      form.requestSubmit(event.submitter);
      allowed.delete(form);
    } catch (error) { showError(error); }
  }, true);
  for (const container of document.querySelectorAll('[data-hnl-saved-item]')) {
    try {
      const item = JSON.parse(container.dataset.hnlItem);
      const spec = await readDesign(item);
      if (!spec) throw new Error('design');
      const image = document.createElement('img');
      image.src = attachmentURL(item.properties['On glass PNG']);
      image.alt = `${copy.saved_design}: ${item.properties['Your Numbers']}`;
      image.loading = 'lazy'; image.width = 300; image.height = 225;
      container.querySelector('[data-hnl-saved-preview]').replaceChildren(image);
      const edit = container.querySelector('[data-hnl-edit]');
      const url = new URL(`${root}products/${styles[spec.draft.style].handle}`, location.origin);
      url.searchParams.set('view', 'number-studio');
      url.searchParams.set('variant', spec.offer.variantId);
      url.searchParams.set('hnl_design', spec.designId);
      url.searchParams.set('hnl_revision', spec.revision);
      if (preview) url.searchParams.set('preview_theme_id', preview);
      edit.href = url.href; edit.hidden = false;
    } catch { container.querySelector('[data-hnl-item-error]').textContent = copy.design_invalid; }
  }
  if (document.querySelector('#cart_form')) {
    try {
      const cart = await api.read();
      if (api.markerOf(cart)) {
        await check();
        location.assign(cartURL.href);
      } else await api.inspect(cart);
    } catch (error) { showError(error); }
  }
}
